import {useEffect} from "react";
import moment from "moment-timezone";

export default function useDataReloadForSchedule(handleTimelineBoundsChanged) {

  useEffect(() => {
    // Hack to make schedule view load with initial data present, as part of VEGAS-239
    const currentTime = moment().add(-12, 'hours').valueOf();
    const endTime = moment(currentTime).add(24, 'hours').valueOf();
    handleTimelineBoundsChanged(currentTime, endTime);
  }, []);
}
